import { BaseService } from './base.service';
import { ErrorWrapper, ResponseWrapper } from './util';

export class InventoryService extends BaseService {
  static async getInventory () {
    try {
      const response = await this.request({ auth: true, v2: true }).get(
        '/admin/inventory'
      );
      
      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async getInventoryRestocks (page = null) {
    try {
      const response = await this.request({ auth: true, v2: true }).get(
        `/admin/inventory/restock/${page}`
      );
      
      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async getInventoryUsage (from = null, to = null) {
    try {
      // startTimestamp=1&endTimestamp=2
      let baseURL = '/admin/inventory/usage';
      const params = [];
      if (from) {
        params.push(`startTimestamp=${from}`);
      }
      if (to) {
        params.push(`endTimestamp=${to}`);
      }
      if (params.length > 0) {
        baseURL += '?' + params.join('&');
      }
      const response = await this.request({ auth: true, v2: true }).get(baseURL);
      
      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async addInventoryRestock (body) {
    try {
      const response = await this.request({ auth: true, v2: true }).post(
        '/admin/inventory/restock',
        body
      );
      
      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async updateInventoryRestock (id, body) {
    try {
      const response = await this.request({ auth: true, v2: true }).put(
        // TEMPORARY
        `/admin/inventory/restock/${id}`,
        body
      );
      
      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async deleteInventoryRestock (id) {
    try {
      const response = await this.request({ auth: true, v2: true }).delete(
        `/admin/inventory/restock/${id}`
      );
      
      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async getInventoryOptions () {
    try {
      const response = await this.request({ auth: true, v2: true }).get(
        '/admin/inventory/options'
      );
      
      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }
}
